import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  standalone: true,
  template: `
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-lg-12">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">500</h1>
            <h4 class="pt-3">INTERNAL SERVER ERROR</h4>
            <p class="text-muted">エラーが発生しました。システム管理者に問い合わせてください。</p>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class ErrorComponent {}
